import React, { memo } from 'react';
import Text from '@wconcept/wconcept-ui-renewal/components/atoms/Text';
import {
  IconClock01,
  IconNotice01,
} from '@wconcept/wconcept-ui-renewal/src/components/atoms/svg';
import * as S from './style';

interface IProps {
  type?: 'clock' | 'notice' | string;
  colorType?: 'gray' | 'black' | 'opacity' | string;
  text?: React.ReactNode;
}

const NoticeBar = ({ type = 'clock', colorType = 'gray', text }: IProps) => (
  <S.NoticeBar className={`notice-bar ${type} color-type-${colorType}`}>
    {type === 'clock' && <IconClock01 />}
    {type === 'notice' && <IconNotice01 />}
    <Text weight={500} size={13} lineHeight="130%" className="notice-bar-text">
      {text}
    </Text>
  </S.NoticeBar>
);

export default memo(NoticeBar);
